import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
// import GD from "../RestAPI/getData";
import Cfa2SubscriptionCheck from '../../RestAPI/Cfa2Subscription';
import PartnerCfa2SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa2Subscription';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import AlertMessage from '../../config/alertMessage';
import PDFModelComponent from '../../Common/PDFModel';
// import { getDeviceDetails } from "../../common/deviceDetails";
// import { getIpAddress } from '../../../common/getIpAddress';
import AppRoutes from '../../config/AppRoutes';
import QuestionNotFoundModal from '../../Common/questionNotFoundModel';
import userStore from "../../../store/userStore";
import { showInformation } from '../../../common/toast';

/* eslint-disable*/
class Cfa2notesreadings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: App_data.messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_1,
      readings: [],
      token: '',
      idname: '',
      chapterid: this.props.params.chapter,
      ValidToken: false,
      chapter_id: '',
      no_result_display: '',
      chapterName: '',
      showFreePremium: true,
      selectedmenu: 'cfa_2',
      checkSubscriptionState: false,
      type: 'notes',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      pdfLoading: true,
      PDFContentMessage: language.LC().PDFContentMessage,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      alert_status_question_not_found: false,
      MessageTitleOnQuestionNotFound: `${language.LC().NOTES}`,
      MessageContentOnQuestionNotFound: `${language.LC().NOTE_NOT_FOUND}`,
      subscriptionstatus: '',
    };
    this.checkSubscriptions();
    this.toggleAlert = this.toggleAlert.bind(this);
    this.pdfAlertModel = this.pdfAlertModel.bind(this);
  }

  toggleAlert() {
    console.log('this.state.subscriptionstatus ', this.state.showFreePremium);
    if (this.state.showFreePremium) {
      this.setState({
        alert_status: !this.state.alert_status,
      });
    } else {
      this.setState({
        alert_status_question_not_found: !this.state.alert_status_question_not_found,
      });
    }
  }

  pdfAlertModel() {
    this.setState({
      pdfAlert: !this.state.pdfAlert,
    });
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to cfanotes page
  _getChapters = e => {
    this.context.router.push({
      pathname: `${AppRoutes.CFA2_2025_NOTES}`,
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  //Function to redirect page to notesviewquestion  page
  _getQuestions = (reading, e) => {
    console.log(reading.reading);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: reading.chapter_no,
      offset: 0,
      limit: 1,
    };
    // console.log(data);
    FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/getNotes', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname: `${AppRoutes.CFA2_2025_NOTES_QUES_VIEW}`
              .replace(':chapter_no', reading.chapter_no)
              .replace(':id', reading.id)
              .replace(':reading', reading.reading),
            state: {
              reading: reading,
              chapter: this.state.chapterid,
            },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  };

  //Function to redirect page on specifc questions
  _beginChapter = (reading, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: reading.chapter_no,
      offset: 0,
      limit: 1,
    };

    FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/getNotes', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          //  : '/cfa2beginnotes/:notesid/:readingid/:id/:chapter/:chapter_no/:offset',
          this.context.router.push({
            pathname: `${AppRoutes.CFA2_2025_BEGIN_NOTES}`
              .replace(':notesid', reading.chapter_no)
              .replace(':readingid', reading.id)
              .replace(':id', resp.questions[0].id)
              .replace(':chapter', this.props.params.chapter)
              .replace(':chapter_no', reading.chapter_no)
              .replace(':offset', 0),
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  };

  // getDerivedStateFromProps for check subscription
  checkSubscriptions = async () => {
    console.log('getDerivedStateFromProps for check subscription===============>');
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapter: this.state.chapterid,
    };

    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
    userStore.getUserProfile(true).then(async resp => {
      // console.log("resp", resp);
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            showFreePremium: true,
            subscriptionstatus: 'free',
          });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = PartnerCfa2SubscriptionCheck.checkCfa2PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        console.log('hello in this');
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          this.setState({
            showFreePremium: true,
            subscriptionstatus: 'free',
          });
        } else {
          console.log('enter');

          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          console.log('dsarafaygdu', data_arr);

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = Cfa2SubscriptionCheck.checkCfa2PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );
                console.log(isInArray_var);
                if (isInArray_var) {
                  this.setState({ showFreePremium: false, checkSubscriptionState: true });
                } else {
                  this.setState({ showFreePremium: true, checkSubscriptionState: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  //On Page Load,init this method
  async componentDidMount() {
    // await this.checkSubscriptions()
    window.scrollTo(0, 0);
    // api to get ip address
    // const result = await getIpAddress();
    // if (result) {
    //   this.setState({
    //     user_city: result.city,
    //     user_country: result.country,
    //     user_ip: result.query,
    //     user_state: result.region,
    //     user_continent: result.continent,
    //   });
    // }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapter: this.state.chapterid,
    };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(
    //   async (resp) => {
    //     // console.log("resp", resp);
    //     if (resp.profileInfo.role === 'partner') {
    //       if (
    //         resp.profileInfo.exam_selected === '' &&
    //         resp.profileInfo.exam_package === ''
    //       ) {
    //         this.setState({
    //           showFreePremium: true,
    //           subscriptionstatus: 'free',
    //         });
    //       } else {
    //         this.setState({
    //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
    //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
    //         });
    //         var data_arr = resp.profileInfo.exam_selected
    //           ? JSON.parse(resp.profileInfo.exam_selected)
    //           : null;

    //         var dataset = {
    //           token: this.state.token,
    //           idname: this.state.idname,
    //           examid: data_arr,
    //         };
    //         await FD.callAPI(
    //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
    //           dataset
    //         ).then((resp_exam) => {
    //           if (resp_exam.success) {
    //             var exam_data = resp_exam.examData;
    //             var selectedmen = this.state.selectedmenu;
    //             var isInArray_var = false;
    //             isInArray_var = PartnerCfa2SubscriptionCheck.checkCfa2PDFSubscription(
    //               selectedmen,
    //               exam_data,
    //               this.state.cfaUnlimitedPackage,
    //               this.state.cfaUnlimitedActiveExam,
    //               this.state.type
    //             );
    //             console.log(isInArray_var);
    //             if (isInArray_var) {
    //               this.setState({ showFreePremium: false });
    //             } else {
    //               this.setState({ showFreePremium: true });
    //             }
    //           } else {
    //             // console.log('fail');
    //           }
    //         });
    //       }
    //     } else {
    //       console.log('hello in this');
    //       if (
    //         resp.profileInfo.exam_selected === '' &&
    //         resp.profileInfo.cfaUnlimitedPackage == '' &&
    //         resp.profileInfo.cfaUnlimitedActiveExam == ''
    //       ) {
    //         this.setState({
    //           showFreePremium: true,
    //           subscriptionstatus: 'free',
    //         });
    //       } else {
    //         console.log('enter');

    //         this.setState({
    //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
    //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
    //         });
    //         var data_arr = resp.profileInfo.exam_selected
    //           ? JSON.parse(resp.profileInfo.exam_selected)
    //           : null;
    //         console.log('dsarafaygdu', data_arr);

    //         var dataset = {
    //           token: this.state.token,
    //           idname: this.state.idname,
    //           examid: data_arr,
    //         };
    //         await FD.callAPI(
    //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
    //           dataset
    //         ).then((resp_exam) => {
    //           console.log(resp_exam);
    //           if (resp_exam.success) {
    //             var exam_data = resp_exam.examData;
    //             var selectedmen = this.state.selectedmenu;
    //             var isInArray_var = false;

    //             isInArray_var = Cfa2SubscriptionCheck.checkCfa2PDFSubscription(
    //               selectedmen,
    //               exam_data,
    //               this.state.cfaUnlimitedPackage,
    //               this.state.cfaUnlimitedActiveExam,
    //               this.state.type
    //             );
    //             console.log(isInArray_var);
    //             if (isInArray_var) {
    //               this.setState({ showFreePremium: false });
    //             } else {
    //               this.setState({ showFreePremium: true });
    //             }
    //           } else {
    //             // console.log('fail');
    //           }
    //         });
    //       }
    //     }
    //   }
    // );
    console.log('I am here -----> ');
    await FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/getReadings', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          readings: resp.readings,
          chapterName: resp.chaptername.chapter_name,
        });
        if (!resp.readings.length) {
          this.setState({ no_result_display: '<h6>No Saved Questions</h6>' });
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
    // var data = { token: this.state.token, idname: this.state.idname };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(
    //   async (resp) => {
    //     // console.log("resp", resp);
    //     if (resp.profileInfo.role === 'partner') {
    //       if (
    //         resp.profileInfo.exam_selected === '' &&
    //         resp.profileInfo.exam_package === ''
    //       ) {
    //         this.setState({
    //           showFreePremium: true,
    //           subscriptionstatus: 'free',
    //         });
    //       } else {
    //         this.setState({
    //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
    //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
    //         });
    //         var data_arr = resp.profileInfo.exam_selected
    //           ? JSON.parse(resp.profileInfo.exam_selected)
    //           : null;

    //         var dataset = {
    //           token: this.state.token,
    //           idname: this.state.idname,
    //           examid: data_arr,
    //         };
    //         await FD.callAPI(
    //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
    //           dataset
    //         ).then((resp_exam) => {
    //           if (resp_exam.success) {
    //             var exam_data = resp_exam.examData;
    //             var selectedmen = this.state.selectedmenu;
    //             var isInArray_var = false;
    //             isInArray_var = PartnerCfa2SubscriptionCheck.checkCfa2PDFSubscription(
    //               selectedmen,
    //               exam_data,
    //               this.state.cfaUnlimitedPackage,
    //               this.state.cfaUnlimitedActiveExam,
    //               this.state.type
    //             );
    //             console.log(isInArray_var);
    //             if (isInArray_var) {
    //               this.setState({ showFreePremium: false });
    //             } else {
    //               this.setState({ showFreePremium: true });
    //             }
    //           } else {
    //             // console.log('fail');
    //           }
    //         });
    //       }
    //     } else {
    //       console.log('hello in this');
    //       if (
    //         resp.profileInfo.exam_selected === '' &&
    //         resp.profileInfo.cfaUnlimitedPackage == '' &&
    //         resp.profileInfo.cfaUnlimitedActiveExam == ''
    //       ) {
    //         this.setState({
    //           showFreePremium: true,
    //           subscriptionstatus: 'free',
    //         });
    //       } else {
    //         console.log('enter');

    //         this.setState({
    //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
    //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
    //         });
    //         var data_arr = resp.profileInfo.exam_selected
    //           ? JSON.parse(resp.profileInfo.exam_selected)
    //           : null;
    //         console.log('dsarafaygdu', data_arr);

    //         var dataset = {
    //           token: this.state.token,
    //           idname: this.state.idname,
    //           examid: data_arr,
    //         };
    //         await FD.callAPI(
    //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
    //           dataset
    //         ).then((resp_exam) => {
    //           console.log(resp_exam);
    //           if (resp_exam.success) {
    //             var exam_data = resp_exam.examData;
    //             var selectedmen = this.state.selectedmenu;
    //             var isInArray_var = false;

    //             isInArray_var = Cfa2SubscriptionCheck.checkCfa2PDFSubscription(
    //               selectedmen,
    //               exam_data,
    //               this.state.cfaUnlimitedPackage,
    //               this.state.cfaUnlimitedActiveExam,
    //               this.state.type
    //             );
    //             console.log(isInArray_var);
    //             if (isInArray_var) {
    //               this.setState({ showFreePremium: false });
    //             } else {
    //               this.setState({ showFreePremium: true });
    //             }
    //           } else {
    //             // console.log('fail');
    //           }
    //         });
    //       }
    //     }
    //   }
    // );
  }

  goPremium() {
    this.context.router.push({
      pathname: `${AppRoutes.SUBSCRIBE}`,
      state: {
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  /*
--------------------
  PDF DOWNLOAD VIA EMAIL
--------------------
*/
  getpdf = async e => {
    if (this.state.pdfLoading === false) {
      alert('Download is in progress....');
      return;
    }
    var data = { token: this.state.token, idname: this.state.idname };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerCfa2SubscriptionCheck.checkCfa2PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                  examPlanData,
                );
                //console.log(isInArray_var);
                if (isInArray_var) {
                  this.setState({
                    pdfLoading: false,
                  });

                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa2_2025_notes/PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
                      this.setState({ pdfLoading: true });
                      showInformation(response.message || "The PDF for this topic is not available yet.");
                    }
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await Cfa2SubscriptionCheck.checkCfa2PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );
                //console.log(isInArray_var);
                if (isInArray_var) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa2_2025_notes/PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
                      this.setState({ pdfLoading: true });
                      showInformation(response.message || "The PDF for this topic is not available yet.");
                    }
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };
  render() {
    let readings = this.state.readings;
    let data = '';
    if (this.state.readings.length) {
      data = readings.map((item, index) => (
        <tr key={index}>
          <td>{item.reading_order}.</td>
          <td>{item.reading}</td>
          <td>
            <span className='tooltip_wrap margin_right_20'>
              <img
                src={App_data.frontend_url + '/img/question_bank/eye_icon.svg'}
                className='pointer_class'
                alt=''
                width='23'
                // aria-disabled={this.state.checkSubscriptionState}
                onClick={this._getQuestions.bind(this, item)}
                id={item.id}
                title=''
              />
              <div className='tootip_box'>{language.LC().VIEW_LIST}</div>
            </span>

            <span className='tooltip_wrap'>
              <img
                src={App_data.frontend_url + '/img/question_bank/open_book_icon.svg'}
                className='pointer_class'
                alt=''
                width='21'
                // aria-disabled={this.state.checkSubscriptionState}

                id={item.id}
                onClick={this._beginChapter.bind(this, item)}
                title=''
              />
              <div className='tootip_box'>{language.LC().BEGIN_NOTES_CHAPTER}</div>
            </span>
          </td>
        </tr>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.state.chapterName}</h1>
          </div>
          <div className='col-md-4 text-md-right margin_bottom_20 notes-download-reading-page'>
            <div onClick={this.getpdf.bind(this)} className='status-download-btn margin_right_10'>
              <a className='btn btn-primary  pointer_class pull-right'>
                {this.state.pdfLoading ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}
                {this.state.showFreePremium ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoading ? language.LC().Download_Notes : '  please wait...'}
              </a>
            </div>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getChapters}
            >
              {language.LC().CHANGE_TOPIC}
            </button>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card height_70vh'>
              <div className='card-header'>{language.LC().CHAPTER_READINGS}</div>
              <div className='table_responsive_wrapper'>
                <div className='table-responsive'>
                  <table className='table_white_bg table'>
                    <thead>
                      <tr className='border_top_0'>
                        <th width='90'>#</th>
                        <th>{language.LC().READING}</th>

                        <th>{language.LC().ACTION}</th>
                      </tr>
                    </thead>
                    <tbody>{data}</tbody>
                  </table>
                  {/*<nav>
                                  <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#">Prev</a></li>
                                    <li className="page-item active">
                                      <a className="page-link" href="#">1</a>
                                    </li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                                    <li className="page-item"><a className="page-link" href="#">Next</a></li>
                                  </ul>
                                </nav>*/}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
        <QuestionNotFoundModal
          alert_status={this.state.alert_status_question_not_found}
          toggleAlert={this.toggleAlert}
          MessageTitle={this.state.MessageTitleOnQuestionNotFound}
          MessageContent={this.state.MessageContentOnQuestionNotFound}
        />
        <PDFModelComponent
          type={'Study Notes'}
          pdfAlertModel={this.pdfAlertModel.bind(this)}
          pdfAlert={this.state.pdfAlert}
          PDFContentMessage={this.state.PDFContentMessage}
        />
      </div>
    );
  }
}

export default Cfa2notesreadings;



// WEBPACK FOOTER //
// ./src/views/CFA2-2025/Notes/Cfa2notesreadings.js